import React, { Fragment, useState } from "react";
import {
  Table,
  TableHeader,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  NoDataFound,
} from "../../../../../components/table/tableComponent";
import { TbEdit } from "react-icons/tb";
import { HiOutlineTrash } from "react-icons/hi";
import { useDispatch } from "react-redux";
import { _removeSession } from "../../../../../../store/slices/baseSetup.slice";
import { deleteSession } from "../../../../../../services/workspace/session.service";
import { Link } from "react-router-dom";
import ConfirmModal from "../../../../../components/modals/ConfirmModel";
import toast from "react-hot-toast";
import TableSkeleton from "../../../../../components/skeleton/tableSkeleton";
import {
  COMMON_PERMISSIONS,
  dateFormat,
  MODULES_LIST,
  SUB_MODULES_LIST,
} from "../../../../../../utils/helper";
import DefaultButton from "../../../../../components/buttons/defaultButton";
import RenderActionButtons from "../../../../../../utils/renderActionButtons";

const TableHeaderData = [
  "Name/Email",
  "Classes",
  "Subjects",
  "Total Marks",
  "Obtained Marks",
  "Percentage",
  "hours",
  "Remarks",
];

const TeacherPerformanceTable = ({
  data = [],
  loading = true,
  removeSessionFromState = () => null,
  search = "",
}) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const onConfirm = () => {
    deleteSession(selectedId)
      .then((response) => {
                        dispatch(_removeSession(selectedId));
        removeSessionFromState(selectedId);
        toast.success("Session deleted successfully!");
      })
      .catch((error) => {
        toast.error(
          `Failed to delete session: ${
            error.response?.data?.message || "Unknown error"
          }`
        );
        console.error(error);
      });
    setIsOpen(false);
  };

  const handleDelete = (id) => {
    setSelectedId(id);
    setIsOpen(true);
  };

  const _actions = (item) => [
    {
      access: COMMON_PERMISSIONS.UPDATE,
      component: (
        <Link
          to={`/configuration/manage-sessions/edit/${item.uuid}`}
          className="text-xl"
        >
          <DefaultButton variant="iconButton" name={<TbEdit />} />
        </Link>
      ),
    },
    {
      access: COMMON_PERMISSIONS.DELETE,
      component: (
        <DefaultButton
          onClick={() => handleDelete(item.uuid)}
          variant="iconButton"
          name={<HiOutlineTrash />}
        />
      ),
    },
  ];

  return (
    <Fragment>
      <Table className="shadow-md">
        <TableHeader>
          <TableRow>
            {TableHeaderData.map((header, index) => (
              <TableHead
                sticky={index === TableHeaderData.length - 1}
                key={index}
                // className={"w-32 min-w-32 max-w-32"}
              >
                {header}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {loading ? (
            <TableSkeleton colSpan={TableHeaderData.length} />
          ) : (
            <Fragment>
              {data.length > 0 ? (
                data.map((item, i) => (
                  <TableRow key={i}>
                    <TableHead className={"bg-white "}>{item.name}</TableHead>
                    {/* <TableCell>{item.abrv || "-"}</TableCell> */}
                    {/* className={"w-32 min-w-32 max-w-32"} */}
                    <TableHead colSpan={6} className={"!p-0 bg-white  "}>
                      {item.classes &&
                        !!item.classes.length ?
                        item.classes.map((classData) => {
                          return (
                            <TableRow>
                              <TableHead className={"bg-white "} >{classData.name}</TableHead>
                              
                                {classData &&
                                  !!classData.subject_list.length &&
                                  classData.subject_list.map((subject, index) => {
                                    return (
                                      <TableRow className={" "}>
                                        <TableHead className={" bg-white border-0  border-x-2  border-b-2"}>{subject?.name}</TableHead>
                                        <TableHead className={"  bg-white border-0  border-x-2   border-b-2"}>{subject?.exam_subject_result_summary?.total_marks}</TableHead>
                                        <TableHead className={"  bg-white border-0  border-x-2   border-b-2"}>{subject?.exam_subject_result_summary?.obtained_marks}</TableHead>
                                        <TableHead className={"  bg-white  border-0  border-x-2  border-b-2"}>{subject?.exam_subject_result_summary?.percentage}</TableHead>
                                        <TableHead className={"  bg-white border-0  border-x-2   border-b-2"}>{subject?.exam_subject_result_summary?.hours}</TableHead>
                                        
                                      </TableRow>
                                    );
                                  })}
                               
                            </TableRow>
                          );
                        }):''}
                    </TableHead>
                    <TableHead className={"b-2 bg-white"}></TableHead>
                    
                    
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <NoDataFound
                    colSpan={TableHeaderData.length}
                    search={search}
                    text={"No sessions found."}
                  />
                </TableRow>
              )}
            </Fragment>
          )}
        </TableBody>
      </Table>

      {/* Confirmation Modal */}
      <ConfirmModal
        isOpen={isOpen}
        title="Are you sure?"
        message="Do you really want to delete this record? This process cannot be undone."
        onConfirm={onConfirm}
        onCancel={() => setIsOpen(false)}
      />
    </Fragment>
  );
};

export default TeacherPerformanceTable;
